var advancedGridItems;
jQuery(document).ready(function(){
    advancedGridItems = jQuery(".wp-block-vif-advanced-grid-item");
    advancedGridItems.addClass('animation pause');
    jQuery(window).scroll(checkGridItems);
    checkGridItems();
    checkGridImages();
});

function checkGridItems(){
    let scrollPos = jQuery(window).scrollTop();
    let windowHeight = jQuery(window).outerHeight(true);
    advancedGridItems.each(function(){
        let currentGridItem = jQuery(this);
        if(currentGridItem.offset().top < scrollPos + windowHeight - 100){
            currentGridItem.removeClass('pause');
            setTimeout(function(){
                currentGridItem.addClass('stop');
            },currentGridItem.hasClass("delay") ? 600 : 400)
        }
        if(!currentGridItem.hasClass('delay') && currentGridItem.find('+.wp-block-vif-advanced-grid-item').length) currentGridItem.find('+.wp-block-vif-advanced-grid-item').addClass('delay')
    })
}

function checkGridImages(){
    jQuery(document).ready(function(){
        advancedGridItems.each(function(){
            let currentGridItem = jQuery(this);
            currentGridItem.find('.wp-block-cover, .wp-block-image').each(function(){
                let currentMedia = jQuery(this);
                if(currentMedia.find('img').length){
                    currentGridItem.addClass('lightbox-item')
                    currentMedia.click(function(e){
                        if(e.target.tagName!=="A"){
                            let modal = jQuery('<div/>').addClass('image-modal');
                            jQuery('body').prepend(
                                modal.append(
                                    currentMedia.find('img').clone()
                                ).click(function(e){
                                    if(e.target.tagName!=='IMG') modal.remove()
                                })
                            )
                        }
                    });
                }
            })
        })
    })
}